import { useMemo, useState } from "react";
import { useDataLayer } from "data-layer";
import { useRoundApprovedApplications } from "../../projects/hooks/useRoundApplications";
import { PresentationChartBarIcon } from "@heroicons/react/24/outline";
import GenericModal from "../../common/GenericModal";
import { ShareButton } from "./ShareButton";
import { ShareStatsButton } from "./ShareStatsButton";
import { Stats } from "./Stats";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const RoundStatsTabContent = _ref => {
  var _round$uniqueDonorsCo, _applications$length;
  let {
    roundId,
    chainId,
    round,
    token,
    tokenSymbol
  } = _ref;
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const dataLayer = useDataLayer();
  const {
    data: applications,
    isLoading: isGetApplicationsLoading
  } = useRoundApprovedApplications({
    chainId,
    roundId
  }, dataLayer);
  const totalUSDCrowdfunded = useMemo(() => {
    var _applications$map$red;
    return (_applications$map$red = applications === null || applications === void 0 ? void 0 : applications.map(application => application.totalAmountDonatedInUsd).reduce((acc, amount) => acc + amount, 0)) !== null && _applications$map$red !== void 0 ? _applications$map$red : 0;
  }, [applications]);
  const totalDonations = useMemo(() => {
    var _applications$map$red2;
    return (_applications$map$red2 = applications === null || applications === void 0 ? void 0 : applications.map(application => {
      var _application$totalDon;
      return Number((_application$totalDon = application.totalDonationsCount) !== null && _application$totalDon !== void 0 ? _application$totalDon : 0);
    }).reduce((acc, amount) => acc + amount, 0)) !== null && _applications$map$red2 !== void 0 ? _applications$map$red2 : 0;
  }, [applications]);
  const ShareModal = () => {
    const ShareModalBody = () => /*#__PURE__*/_jsxs("div", {
      className: "items-center gap-y-2 gap-x-4 mt-10 w-full grid sm:grid-cols-2",
      children: [/*#__PURE__*/_jsx(ShareButton, {
        round: round,
        tokenSymbol: tokenSymbol,
        totalUSDCrowdfunded: totalUSDCrowdfunded,
        totalDonations: totalDonations,
        type: "TWITTER"
      }), /*#__PURE__*/_jsx(ShareButton, {
        round: round,
        tokenSymbol: tokenSymbol,
        totalUSDCrowdfunded: totalUSDCrowdfunded,
        totalDonations: totalDonations,
        type: "FARCASTER"
      })]
    });
    return /*#__PURE__*/_jsx(GenericModal, {
      title: "Share this round\u2019s stats on social media!",
      titleSize: "lg",
      body: /*#__PURE__*/_jsx(ShareModalBody, {}),
      isOpen: isShareModalOpen,
      setIsOpen: setIsShareModalOpen
    });
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("section", {
      className: "flex flex-col gap-10 sm:gap-16",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "w-full",
        children: [/*#__PURE__*/_jsx("div", {
          className: "flex justify-end items-center gap-2",
          children: /*#__PURE__*/_jsx(ShareStatsButton, {
            handleClick: () => setIsShareModalOpen(true)
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "max-w-[60rem] w-full m-auto mt-12",
          children: /*#__PURE__*/_jsx(Stats, {
            token: token,
            tokenSymbol: tokenSymbol,
            round: round,
            totalCrowdfunded: totalUSDCrowdfunded,
            totalDonations: totalDonations,
            totalDonors: (_round$uniqueDonorsCo = round.uniqueDonorsCount) !== null && _round$uniqueDonorsCo !== void 0 ? _round$uniqueDonorsCo : 0,
            totalProjects: (_applications$length = applications === null || applications === void 0 ? void 0 : applications.length) !== null && _applications$length !== void 0 ? _applications$length : 0,
            chainId: chainId,
            statsLoading: isGetApplicationsLoading
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "max-w-[53rem] m-auto w-full bg-green-50 rounded-2xl py-8 px-2 flex justify-center items-center gap-8 flex-wrap",
        children: [/*#__PURE__*/_jsx("p", {
          className: "text-xl sm:text-2xl font-medium",
          children: "Want to check out more stats?"
        }), /*#__PURE__*/_jsxs("a", {
          href: `https://reportcards.gitcoin.co/${chainId}/${roundId}`,
          target: "_blank",
          className: "rounded-lg px-4 py-2.5 font-mono bg-green-200 hover:bg-green-300 text-white transition-all flex items-center justify-center gap-2",
          "data-testid": "share-results-footer",
          children: [/*#__PURE__*/_jsx(PresentationChartBarIcon, {
            className: "w-4 h-4"
          }), /*#__PURE__*/_jsx("span", {
            children: "Round report card"
          })]
        })]
      }), /*#__PURE__*/_jsx(ShareModal, {})]
    })
  });
};